import React, { useEffect, useState } from 'react';
import {
    Grid,
    TextField,
    Checkbox,
    FormControlLabel,
    Button,
    Stack,
    Typography,
    Box
} from '@mui/material';
import CredoitBanner from '../../../assets/credoit-banner.png';
import VemigoLogo from '../../../assets/vemigo-logo.png';
import { useAuth } from 'src/contexts/AuthContext';
import { Navigate, useNavigate } from 'react-router-dom';
import userManagementServices from 'src/services/userManagement/userManagementServices';
import { useUser } from '../settings/userManagement/user/userContext';

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const { token, login } = useAuth();
    const { setToken } = useUser()
    const navigate = useNavigate();

    if (token) {
        return <Navigate to="/dashboards" replace />;
    }

    const handleLogin = async (e) => {
        e.preventDefault();
        try {
            const response = await userManagementServices.login({ Email: email, Password: password });
      const { access_token, refresh_token } = response.data;
            if (access_token && refresh_token) {
        login(access_token, refresh_token);
                setToken(access_token);
                navigate('/dashboards', { replace: true });
            }
        } catch (error) {
            console.error('Login failed:', error);
        }
    };
    return (

        <Box sx={{ height: '100vh', overflow: 'hidden' }}>
            <Grid container sx={{ height: '100%' }}>
                <Grid
                    item
                    md={4}
                    sx={{
                        display: { xs: 'none', md: 'block' },
                        height: '100%',
                    }}
                >
                    <div
                        className='img-container'
                        style={{
                            width: '100%',
                            height: '100%',
                        }}
                    >
                        <img
                            src={CredoitBanner}
                            alt="Credoit Banner"
                            style={{
                                width: '100%',
                                height: '100%',
                            }}
                        />
                    </div>

                </Grid>

                <Grid
                    item
                    xs={12}
                    md={8}
                    sx={{
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        px: 2,
                    }}
                >
                    <Box sx={{ textAlign: 'center' }}>
                        <Box
                            component="img"
                            src={VemigoLogo}
                            alt="Vemigo"
                            sx={{ width: '400px', mb: 4 }}
                        />
                        <Typography variant="h5" gutterBottom>
                            Log in to your account
                        </Typography>
                    </Box>

                    <Box sx={{ width: '100%', maxWidth: '400px', mt: 2 }}>
                        <form onSubmit={handleLogin}>
                            <TextField
                                fullWidth
                                label="Email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                margin="normal"
                            />
                            <TextField
                                fullWidth
                                label="Password"
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                margin="normal"
                            />
                            <Button type="submit" fullWidth variant="contained" size="large">
                                Login
                            </Button>
                        </form>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
};

export default Login;
